import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {map, take, shareReplay, tap} from 'rxjs/operators';
import {Observable, ReplaySubject, of} from 'rxjs';
import {downgradeInjectable} from '@angular/upgrade/static';
// @ts-ignore
declare var angular: angular.IAngularStatic;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userRequest$: Observable<UserData>;
  private userToken: string;
  userData$: ReplaySubject<UserData> = new ReplaySubject<UserData>(1);

  constructor(
    private readonly http: HttpClient,
    @Inject('$rootScope') private $rootScope: any,
    @Inject('tokenSvc') private tokenSvc: any,
  ) {
    this.getUser().subscribe({error: () => {}});
    $rootScope.$on('userChanged', (event, user) => {
      if (user?.login) {
        this.getUser().subscribe({error: () => {}});
      }
    });
  }

  hasWritePermission(): Observable<boolean> {
    const user = this.tokenSvc.GetUser();
    return of(!!user && user.hasDispoWriteAccess);
  }

  getUser(): Observable<UserData> {
    const user = this.tokenSvc.GetUser();
    if (!user) {
      this.userRequest$ = null;
      this.userToken = null;
      this.userData$.next(null);
      return of(null);
    }
    const token = this.tokenSvc.GetToken();
    if (user.firstName !== undefined) {
      this.userData$.next(user);
      return of(user);
    }
    if (this.userRequest$ && this.userToken === token) return this.userRequest$;
    this.userToken = token;
    this.userRequest$ = this.http.get<UserData>(environment.rootUrl + `/api/disposition/user/${encodeURIComponent(user.loginName)}`)
      .pipe(
        take(1),
        map(profile => ({...profile, ...user})),
        tap((res) => {
          if (this.tokenSvc.GetToken() === token) {
            this.tokenSvc.CacheUser(res);
            this.userData$.next(res);
          }
        }),
        shareReplay(1)
      );
    return this.userRequest$;
  }

  logout() {
    this.tokenSvc.CleanUpAuthData();
    this.userRequest$ = null;
    this.userToken = null;
    this.userData$.next(null);
    location.href = `/#!/login`;
  }
}

export class UserData {
  [key: string]: any
}

angular.module('mmi.tp.disposition').factory('authService', downgradeInjectable(AuthService));
